import { render, staticRenderFns } from "./AtlasAssistant.vue?vue&type=template&id=7f23a7df&scoped=true"
import script from "./AtlasAssistant.vue?vue&type=script&lang=js"
export * from "./AtlasAssistant.vue?vue&type=script&lang=js"
import style0 from "./AtlasAssistant.vue?vue&type=style&index=0&id=7f23a7df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f23a7df",
  null
  
)

export default component.exports